import { TruckingRouteActions } from "@shared/src/enums/TruckingRouteActions";
export class TruckingRouteExecuteActionDto {

	public action: TruckingRouteActions;
	public routeId: number;
	public shipmentId: number;
	public packageId: number;
	
	public static build(action: TruckingRouteActions, routeId: number, shipmentId: number, packageId: number): TruckingRouteExecuteActionDto{
		let value = new TruckingRouteExecuteActionDto();
		value.action = action;
		value.routeId = routeId;
		value.shipmentId = shipmentId;
		value.packageId = packageId;
		return value;
	} 
}
